import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";
import { Seo } from "@/components/common/Seo";

export default function InsightDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(undefined);
  useEffect(() => {
    api.get(`/api/insights/${slug}`).then((r) => setPost(r.data)).catch(() => setPost(null));
  }, [slug]);

  if (post === undefined) return <div className="container-x py-40 text-center text-ink-muted">Loading…</div>;
  if (post === null)
    return (
      <div className="container-x py-40 text-center">
        <p className="text-ink-heading text-xl font-semibold">Article not found</p>
        <Link to="/insights" className="mt-4 inline-block text-azeka-teal font-medium">Back to Insights</Link>
      </div>
    );

  const jsonLd = {
    "@context": "https://schema.org", "@type": "Article", headline: post.title,
    description: post.excerpt, author: { "@type": "Organization", name: post.author || "Azeka Global Trade FZCO" },
    datePublished: post.published_at,
  };

  return (
    <article data-testid="page-insight-detail" className="pt-28">
      <Seo title={`${post.seo?.title || post.title} | Azeka Global`} description={post.seo?.description || post.excerpt} path={`/insights/${post.slug}`} image={post.cover_image} jsonLd={jsonLd} />
      <div className="container-x max-w-3xl">
        <Link to="/insights" className="inline-flex items-center gap-2 text-sm font-semibold text-azeka-teal hover:text-azeka-navy transition-colors">
          <ArrowLeft className="h-4 w-4" /> All insights
        </Link>
        <h1 className="mt-6 text-3xl sm:text-4xl font-bold tracking-tight text-ink-heading leading-tight">{post.title}</h1>
        {post.author ? <p className="mt-3 text-sm text-ink-muted">By {post.author}</p> : null}
      </div>
      {post.cover_image ? (
        <div className="container-x max-w-4xl mt-10">
          <img src={post.cover_image} alt={post.title} className="w-full rounded-2xl object-cover max-h-[440px]" />
        </div>
      ) : null}
      <div className="container-x max-w-3xl py-12">
        <div className="prose prose-slate max-w-none text-ink-body leading-relaxed whitespace-pre-wrap" data-testid="insight-body">
          {post.body}
        </div>
      </div>
    </article>
  );
}
